import React from 'react';

export const PolygonLogo = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="#8247E5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.67621 4.41723C6.87758 4.30537 7.12238 4.30537 7.32375 4.41723L10.3237 6.0839C10.5354 6.20147 10.6666 6.42457 10.6666 6.66667V7.75057L9.33331 8.5V7.05893L6.99998 5.76263L4.66665 7.05893V9.60773L6.99998 10.904L12.6762 7.75057C12.8776 7.6387 13.1224 7.6387 13.3237 7.75057L16.3237 9.41723C16.5354 9.5348 16.6666 9.7579 16.6666 10V13.3333C16.6666 13.5754 16.5354 13.7985 16.3237 13.9161L13.3237 15.5828C13.1224 15.6946 12.8776 15.6946 12.6762 15.5828L9.67621 13.9161C9.46458 13.7985 9.33331 13.5754 9.33331 13.3333V12.2494L10.6666 11.5V12.9411L13 14.2374L15.3333 12.9411V10.3923L13 9.09597L7.32375 12.2494C7.12238 12.3613 6.87758 12.3613 6.67621 12.2494L3.67621 10.5828C3.46458 10.4652 3.33331 10.2421 3.33331 10V6.66667C3.33331 6.42457 3.46458 6.20147 3.67621 6.0839L6.67621 4.41723Z"
        fill="white"
      />
    </svg>
  );
};
